import {useAppSelector} from '../../../store/store';
import styles from '../../../components/sliding_form_wizard/sliding_wizard.module.scss';
import buttonStyles from '../../../components/button/button.module.scss';
import {Button} from '../../../components/button/button';
import {__} from '../../../support/lang/translations';
import {ButtonColorType} from '../../../enums/button_color_type.ts';
import {LocationType} from '../../../gql/pwa/graphql.ts';
import {Status} from '../../../enums/status.ts';
import {CenteredSpinner} from '../../../components/spinner/centered_spinner.tsx';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';

interface TitleProps {
    locationId: number | null;
}

export function LocationSelectTitle(props: TitleProps) {
    const appConfig = useAppSelector((state) => state.appConfig);

    const location = initialLocation(appConfig.locations || [], props.locationId);

    return (
        <>
            <h1>{__('appointment.location_select.title')}</h1>
            <h2>
                {location?.name
                    ? __('appointment.location_select.subtitle', {location: location.name})
                    : __('appointment.location_select.subtitle_unknkown')}
            </h2>
        </>
    );
}

interface TitleProps {
    brand?: string | null;
}
export function VehicleSelectTitle(props: TitleProps) {
    return (
        <>
            <h1>{__('appointment.vehicle_select.title')}</h1>
            {props.brand != null && <h2>{__('appointment.vehicle_select.subtitle', {brand: props.brand})}</h2>}
        </>
    );
}

interface ContentProps {
    isEditing: boolean;
    locationId: number | null;
}

function initialLocation(
    locations: (LocationType | null)[],
    defaultLocationId: number | null | undefined,
): LocationType | null {
    return locations?.find((location) => location?.id === defaultLocationId) || locations[0];
}

export function LocationSelectContent(props: ContentProps) {
    const customerInfo = useAppSelector((state) => state.customerInfo);
    const appConfig = useAppSelector((state) => state.appConfig);

    if (customerInfo.status !== Status.FULFILLED) {
        return <CenteredSpinner />;
    }

    const locations = appConfig.locations;
    if (!locations || locations.length === 0) {
        return (
            <FlexRow alignment={Alignment.Center}>
                <FlexColumn alignment={Alignment.Center}>
                    <div>
                        <h3>{__('appointment.location_select.empty.title')}</h3>
                        <p style={{maxWidth: 450}}>{__('appointment.location_select.empty.message')}</p>
                    </div>
                </FlexColumn>
            </FlexRow>
        );
    }
    const selectedLocation = locations.find((location) => location?.id === props.locationId);
    if (!props.locationId || !selectedLocation) {
        return (
            <FlexRow alignment={Alignment.Center}>
                <FlexColumn alignment={Alignment.Center}>
                    <div>
                        <h3>{__('appointment.location_select.no_location.title')}</h3>
                        <p style={{maxWidth: 450}}>{__('appointment.location_select.no_location.message')}</p>
                    </div>
                </FlexColumn>
            </FlexRow>
        );
    }

    return (
        <>
            {selectedLocation.photo_url && (
                <div className={styles.content_slide_content_image}>
                    <img
                        src={selectedLocation.photo_url}
                        alt={selectedLocation.name || ''}
                        onError={(e) => (e.currentTarget.style.display = 'none')}
                    />
                </div>
            )}
            <h2 style={{margin: '2rem 0 0 0'}}>{selectedLocation.name}</h2>
        </>
    );
}

interface FooterProps {
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
    onPrevSlide: () => void;
    onNextSlide: () => void;
}

export function LocationSelectFooter(props: FooterProps) {
    return (
        <>
            <Button
                className={buttonStyles.button_step}
                type="button"
                onClick={() => props.setIsEditing(true)}
                colorType={ButtonColorType.Black}
            >
                <i className="fa-light fa-pen" />
                <span>{__('appointment.location_select.footer.buttons.select')}</span>
            </Button>

            <Button
                className={buttonStyles.button_step}
                type="button"
                onClick={() => props.onNextSlide()}
                colorType={ButtonColorType.Green}
            >
                <i className="fa-light fa-check" />
                <span>{__('appointment.location_select.footer.buttons.next')}</span>
            </Button>
        </>
    );
}
